var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "column justify-center items-center" },
    [
      _c(
        "q-card",
        { staticClass: "accept-invite-card bg-white" },
        [
          _c("q-card-main", [
            _c(
              "div",
              { staticClass: "row justify-center q-mt-lg" },
              [
                _c("team-logo", {
                  staticClass: "q-display-3",
                  attrs: { team: _vm.team, height: "120px", width: "120px" }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _c(
                  "i18n",
                  {
                    staticClass: "q-my-lg q-body-1",
                    attrs: { tag: "div", path: "invite_text" }
                  },
                  [
                    _c(
                      "h4",
                      { staticClass: "no-margin", attrs: { place: "team" } },
                      [_vm._v(_vm._s(_vm.invite.team))]
                    )
                  ]
                ),
                _c("p", [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("access_rights")) + ":"
                  ),
                  _c("br"),
                  _c("span", { staticClass: "text-faded" }, [
                    _vm._v(_vm._s(_vm.roleName))
                  ])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "row justify-center" },
              [
                _vm.authenticated
                  ? [
                      _c(
                        "q-btn",
                        {
                          attrs: { type: "submit", color: "primary" },
                          on: { click: _vm.accept }
                        },
                        [_vm._v(_vm._s(_vm.$t("accept")))]
                      )
                    ]
                  : [
                      _c(
                        "q-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function($event) {
                              _vm.setUrlAndRedirect("login")
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("login")))]
                      ),
                      _c(
                        "q-btn",
                        {
                          staticClass: "on-right",
                          attrs: { color: "primary" },
                          on: { click: _vm.handleRegister }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("register")))]
                      )
                    ]
              ],
              2
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }